import React from "react"
import PropTypes from "prop-types"
import { useTracker } from "@modules/analytics"
import useToggleIncrementalBuilds from "../hooks/useToggleIncrementalBuilds"
import { siteBuildsSettings as text } from "@modules/locales/default.js"
import { ToggleCheckbox, Link, Spacer } from "gatsby-interface"
import { FormattedMessage } from "@modules/locales"
import { MdArrowForward, MdInfoOutline } from "react-icons/md"
import { useWorkspaceDetailsShortcuts } from "@modules/organization/builds/hooks/useWorkspaceDetailsShortcuts"
import { getPathToUpgradeToProfessional } from "@modules/organization/shared/utils"

const propTypes = {
  siteId: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
  incrementalBuildsEnabled: PropTypes.bool,
}

export default function IncrementalBuildsSettings({
  siteId,
  organizationId,
  incrementalBuildsEnabled,
}) {
  const [toggleIncrementalBuilds, { errorAlert }] = useToggleIncrementalBuilds(
    siteId
  )
  const { trackButtonClicked } = useTracker()

  const workspace = useWorkspaceDetailsShortcuts(organizationId)

  const pathToUpgrade = getPathToUpgradeToProfessional(organizationId)

  return (
    <React.Fragment>
      <ToggleCheckbox
        id="enable-incremental-builds-checkbox"
        label={
          <React.Fragment>
            {text.labels.enableIncrementalBuilds}
            <Spacer direction="horizontal" size={3} />
            <Link
              href={`https://gatsby.dev/site-settings-enable-cloud-builds-info`}
              title={text.labels.learnAboutCloudBuilds}
            >
              <MdInfoOutline />
            </Link>
          </React.Fragment>
        }
        hint={
          <React.Fragment>
            {text.messages.incrementalBuildsForContentUpdates}{" "}
            {workspace.isOnFreePlan && (
              <FormattedMessage
                message={text.messages.notAvailableForFreePlan}
                tags={{
                  link: function(content) {
                    return (
                      <Link to={pathToUpgrade} variant="SIMPLE">
                        {content} <MdArrowForward />
                      </Link>
                    )
                  },
                }}
              />
            )}
          </React.Fragment>
        }
        checked={!!incrementalBuildsEnabled}
        onChange={() => {
          trackButtonClicked(`toggle incremental builds`, {
            uiSource: `Site Settings`,
          })

          toggleIncrementalBuilds()
        }}
        disabled={workspace.isOnFreePlan}
      />
      {errorAlert}
    </React.Fragment>
  )
}

IncrementalBuildsSettings.propTypes = propTypes
